<template>
	<div>
		<div style="display: flex;">
			<p class="admintitle">Users</p>
			<span style="margin-left: 30px; height: 28px;" class="mark-complete-btn" @click="createNewPopup">
				Create New
			</span>
			<div style="display: inline-block; margin-left: 30px; margin-top: 2px;">
				<b-form-checkbox v-model="showInactive" switch>
					<span style="display: inline-block; font-size: 12px; color: #888; margin-top: 6px;">Show Inactive</span>
				</b-form-checkbox>
			</div>
		</div>

		<b-input type="text" v-model="searchtext" class="adminsearchbox"></b-input>

		<div class="admin-structure">

			<div class="admin-listview">
				<div v-for="li in shownObjects" :key="li.id"
					class="admin-list-row" :class="{highlighted : activeItemId === li.id}"
					@click="setActiveItem(li.id)"
				>
					<span>{{li.name}} ({{li.email}})</span>
				</div>
			</div>
			<div class="admin-infoview">
				<div v-if="activeItem">
					<div class="admin-info-section" style="display: flex; justify-content: space-between; align-items: center;">
						<span class="admin-item-title">{{activeItem.name}}</span>
					</div>
					<div class="admin-info-section info-data">
						<p><span class="item-label">User ID:</span> {{activeItem.id}}</p>
					</div>
					<div class="admin-info-section">
						<p class="input-label">User Name</p>
						<b-input class="admin-input" type="text" v-model="editingReport.name"></b-input>
						<p class="input-label">Email</p>
						<b-input class="admin-input" type="text" v-model="editingReport.email"></b-input>
						<p class="input-label">Password</p>
						<b-input class="admin-input" type="text" v-model="editingReport.password"></b-input>
						<p class="input-label">Status</p>
						<b-form-select v-model="editingReport.status" class="admin-input">
							<option value="active">Active</option>
							<option value="disabled">Disabled</option>
						</b-form-select>
						<ActionButton style="margin-top: 20px;" buttontext="Save Info" v-on:clicked="saveDetails" :isworking="saveDetailsWorking"></ActionButton>
					</div>


				</div>
			</div>

			<b-modal id="modal-create-new" ref="modal-create-new" title="Create New User Record" hide-footer>
				<div class="modal-inner" style="padding-top: 10px; padding-bottom: 10px;">
					<p class="input-label">User Name</p>
					<b-input class="admin-input" type="text" v-model="newReport.name"></b-input>
					<p class="input-label">User Email</p>
					<b-input class="admin-input" type="text" v-model="newReport.email"></b-input>
					<ActionButton style="margin-top: 10px;" buttontext="Save New User" v-on:clicked="saveNewFromPopup" :isworking="saveNewIsWorking"></ActionButton>
				</div>
			</b-modal>

		</div>
	</div>
</template>

<script>
import axios from "axios";
import ActionButton from "@/components/ActionButton";

export default {
	name: "Users",
	components: {ActionButton},
	props: {},
	data: function () {
		return {
			isFetching: false,
			searchtext: '',
			activeItemId: 0,

			userlist: [],

			editingReport: {
				id: 0,
				name: '',
				email: '',
				status: '',
				password: '',
			},

			newReport: {
				id: 0,
				name: '',
				email: '',
			},

			showInactive: false,

			saveDetailsWorking: false,
			saveNewIsWorking: false,

		}
	},
	computed: {
		listObjects() {
			if(this.showInactive === false) {
				return this.userlist.filter(item => item.status === 'active');
			}
			return this.userlist;
		},
		shownObjects() {
			if (this.searchtext.length > 0) {
				var src = this.searchtext.toLowerCase();
				return this.listObjects.filter(item =>
					(item.name.toLowerCase().includes(src) || item.email.toLowerCase().includes(src))
				);
			}
			return this.listObjects; //return all if limit not set
		},
		activeItem() {
			return this.userlist.find(item => item.id === this.activeItemId);
		},
	},
	methods: {
		createNewPopup() {
			this.newReport = {
				id: 0,
				name: '',
				email: '',
			};
			this.$refs['modal-create-new'].show();
		},
		fetchUserList() {
			if(this.isFetching === false) {
				var self = this;
				var targ = '/post/admin/get-users.php';
				axios.get(targ).then(function (response) {
					var ret = response.data; //response.data is returned info
					self.userlist = ret.users;
					self.isFetching = false;
				}).catch(function (error) {
					console.log(error);
					self.isFetching = false;
				});
			}
		},
		saveNewFromPopup() {
			if(this.newReport.name.length > 0 && this.newReport.email.length > 0) {
				if(this.saveNewIsWorking === false) {
					var form = {};
					form.editingReport = this.newReport;
					this.saveNewIsWorking = true;
					var self = this;
					var targ = '/post/admin/save-user-details.php';
					axios.post(targ, form).then(function (response) {
						var ret = response.data; //response.data is returned info
						self.userlist = ret.users;
						self.setActiveItem(ret.activeUserId);
						self.$refs['modal-create-new'].hide();
						self.saveNewIsWorking = false;
					}).catch(function (error) {
						console.log(error);
						self.saveNewIsWorking = false;
					});
				}
			}
			else {
				alert("Please enter a user name and email address");
			}
		},
		setActiveItem(id) {
			this.activeItemId = id;
			this.editingReport.id = this.activeItem.id;
			this.editingReport.name = this.activeItem.name;
			this.editingReport.email = this.activeItem.email;
			this.editingReport.status = this.activeItem.status;
			this.editingReport.password = this.activeItem.password;
		},
		saveDetails() {
			if(this.saveDetailsWorking === false) {
				var form = {};
				form.editingReport = this.editingReport;
				this.saveDetailsWorking = true;
				var self = this;
				var targ = '/post/admin/save-user-details.php';
				axios.post(targ, form).then(function (response) {
					var ret = response.data; //response.data is returned info
					self.userlist = ret.users;
					self.saveDetailsWorking = false;
				}).catch(function (error) {
					console.log(error);
					self.saveDetailsWorking = false;
				});
			}
		},
	},
	watch: {
		listObjects() {
			if(this.activeItemId === 0) {
				this.setActiveItem(this.listObjects[0].id);
			}
		},
	},
	mounted() {
		this.fetchUserList();
	}
}
</script>

<style scoped>

</style>